<template>
  <div class="oa_pc">
    <page-head :isLogo="false"></page-head>
    <div class="main">
      <div class="content" id="pageContent">
        <router-view></router-view>
        <p class="copy">浙ICP备12004338号-5 | &copy;2020 杭州中仓供应链科技(集团)有限公司所有</p>
      </div>
    </div>
  </div>
</template>

<script>
import PageHead from "components/layout/PageHead";
export default {
  components: {
    PageHead,
  },
  data() {
    return {
      name: "",
    };
  },
  created() {
    this.name = this.$route.matched[1].path;
  },
  watch: {
    $route: {
      handler() {
        this.name = this.$route.matched[1].path;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.oa_pc {
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    display: flex;
    overflow: hidden;
    .content {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      background: #f2f4f8;
      padding: 16px;
      box-sizing: border-box;
      box-shadow: inset 7px 7px 6px rgba(51, 51, 51, 0.06);
      .copy {
        margin-top: 16px;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        text-align: center;
      }
    }
    .contentMenu {
      padding: 0;
    }
  }
}
</style>
<style lang="scss">
.el-button {
  height: 32px;
  line-height: 0px;
  font-size: 14px;
  letter-spacing: 1px;
}
.el-button.btn-text {
  color: #2e68ea;
  font-size: 14px;
}
.el-button.btn-text:active {
  color: #2e68ea;
  font-size: 14px;
}
.el-button.btn-white {
  border: 1px solid #2e68ea;
  background: rgba(255, 255, 255, 1);
  color: #3d74f2;
}
.el-button.btn-white:hover {
  border: 1px solid rgba(46, 104, 234, 0.75);
  background: rgba(46, 104, 234, 0.75);
  color: #fff;
}
.el-button.btn-blue {
  border: 1px solid #2e68ea;
  background: #2e68ea;
  color: #fff;
}
.el-button.btn-blue:hover {
  background: rgba(55, 103, 214, 1);
  border: 1px solid rgba(55, 103, 214, 1);
  color: #fff;
}
.el-button.disabled {
  border: 0;
  background: #eee;
  color: #aaa;
}
.el-button.disabled:hover {
  border: 0;
  background: #eee;
  color: #aaa;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background-color: #2e68ea;
  border-color: #2e68ea;
  -webkit-box-shadow: -1px 0 0 0 #2e68ea;
  box-shadow: -1px 0 0 0 #2e68ea;
}
.el-select.gray {
  .el-input__inner {
    height: 32px;
    background: rgba(234, 238, 245, 0.2);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    padding: 0 20px 0 8px;
    font-size: 14px;
    font-family: "PingFangSC-Regular";
    color: rgba(96, 98, 102, 1);
    letter-spacing: 1px;
    padding-left: 15px;
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
  }
  .is-focus {
    .el-input__inner {
      border: 1px solid rgba(61, 116, 242, 1);
    }
  }
}
.el-select.white {
  .el-input__inner {
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    padding: 0 20px 0 8px;
    font-size: 14px;
    font-family: "PingFangSC-Regular";
    color: rgba(96, 98, 102, 1);
    letter-spacing: 1px;
    padding-left: 15px;
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
  }
  .is-focus {
    .el-input__inner {
      border: 1px solid rgba(61, 116, 242, 1);
    }
  }
}
.el-cascader {
  /* width: 300px; */
  height: 32px;
  line-height: 32px;
  .el-input {
    .el-input__inner {
      height: 32px;
      background: rgba(234, 238, 245, 0.2);
      border: 1px solid #eaeef5;
    }
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
  }
  .is-focus {
    .el-input__inner {
      border: 1px solid rgba(61, 116, 242, 1);
    }
  }
}
.el-input.gray {
  .el-input__inner {
    height: 32px;
    background: rgba(234, 238, 245, 0.2);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
  }
  .el-input__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-input__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
    cursor: pointer;
  }
}
.el-input.white {
  .el-input__inner {
    height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(235, 238, 242, 1);
  }
  .el-input__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-input__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
    cursor: pointer;
  }
}
.el-input.disabled {
  .el-input__inner {
    height: 32px;
    background: rgba(227, 231, 237, 0.5);
    border-radius: 4px;
    border: 1px solid rgba(219, 223, 230, 1);
  }
}
.el-textarea.gray {
  .el-textarea__inner {
    background: rgba(234, 238, 245, 0.2);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
  }
  .el-textarea__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-textarea__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
}
.table-img {
  .el-table {
    font-family: "PingFangSC-Regular";
    border: 1px solid #f2f6fc;
    border-bottom: 0;
    border-radius: 8px 8px 0px 0px;
    .el-table__empty-block {
      background: #fff;
    }
    .el-table__header-wrapper {
      background: #f5f7fa;
      .el-table__header {
        tr {
          th {
            background: #f5f7fa;
            padding: 0;
            .cell {
              color: #606266;
              line-height: 32px;
              height: 32px;
              font-size: 14px;
              letter-spacing: 1px;
              padding: 0 16px;
            }
          }
        }
      }
    }
    .el-table__body-wrapper {
      .el-table__body {
        tr {
          min-height: 54px;
          td {
            min-height: 54px;
            padding: 2px 0px;
            .cell {
              color: #606266;
              /* height: 64px; */
              padding: 5px 16px;
              font-size: 12px;
              /* line-height: 64px; */
              display: flex;
              justify-content: flex-start;
              align-items: center;
              letter-spacing: 1px;
              line-height: 16px;
              font-family: "Microsoft YaHei";
              .img {
                width: 40px;
                min-width: 40px;
                max-width: 40px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                margin-right: 16px;
              }
              .name {
                width: 240px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                font-size: 12px;
                line-height: 23px;
                letter-spacing: 0px;
                white-space: pre-wrap;
              }
              .el-button {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
.table {
  .el-table {
    font-family: "PingFangSC-Regular";
    border: 1px solid #f2f6fc;
    border-bottom: 0;
    border-radius: 8px 8px 0px 0px;
    .el-table__header-wrapper {
      background: #f5f7fa;
      .el-table__header {
        tr {
          th {
            background: #f5f7fa;
            padding: 0;
            height: 32px;
            .cell {
              color: #606266;
              line-height: 16px;
              padding: 8px 16px;
              font-size: 14px;
            }
          }
        }
      }
    }
    .el-table__body-wrapper {
      .el-table__body {
        tr {
          height: 32px;
          padding: 0;
          td {
            height: 32px;
            padding: 0;
            .cell {
              color: #606266;
              font-size: 14px;
              padding: 0 0 0 16px;
              height: 32px;
              line-height: 32px;
            }
          }
        }
      }
    }
  }
}
.el-date-editor.el-input {
  border: 0;
  .el-input__inner {
    height: 32px;
    border: 1px solid rgba(234, 238, 245, 1);
  }
  .el-input__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-input__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
  .el-input__prefix {
    height: 40px;
    top: -3px;
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
  }
}
.el-date-editor {
  height: 32px;
  border: 1px solid rgba(234, 238, 245, 1);
  .el-range-input {
    height: 30px;
  }
  .el-range-separator {
    line-height: 24px;
  }
  .el-range__icon {
    line-height: 24px;
  }
  .el-input__icon {
    line-height: 24px;
  }
}
.el-form {
  .is-success {
    .el-input__inner:focus {
      border-color: #3d74f2;
    }
  }
  /* .is-error {
    .el-input__inner {
    }
  } */
  .el-form-item {
    margin-bottom: 16px;
    .el-form-item__label {
      line-height: 32px;
      color: #606266;
      padding: 0;
    }
    .el-form-item__content {
      line-height: 32px;
      .el-form-item__error {
        padding-top: 2px;
      }
    }
  }
}
/* el-radio */
.el-radio-group {
  .el-radio-button {
    .el-radio-button__inner {
      padding: 8px 20px;
    }
  }
}
.secondary-menu-container {
  .secondary-menu-title {
    height: 40px;
    line-height: 40px;
    color: rgba(48, 49, 51, 1);
    font-weight: 500;
    letter-spacing: 1px;
    width: 120px;
    text-align: center;
  }
}
.el-dialog {
  border-radius: 4px;
  .el-dialog__header {
    padding: 0 24px;
    line-height: 48px;
    color: #606266;
    font-family: "PingFangSC-Medium";
    letter-spacing: 1px;
    .el-dialog__title {
      font-size: 16px;
      color: #606266;
      font-weight: 500;
    }
    .el-dialog__headerbtn {
      top: 15px;
    }
  }
  .el-dialog__body {
    padding: 0px 16px 16px 16px;
    .border {
      border-bottom: 1px solid #f7f7f7;
      margin-bottom: 16px;
    }
    .el-form {
      .el-form-item {
        margin-bottom: 16px;
      }
      .el-form-item:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.messageBox {
  width: 320px!important;
  .el-message-box__header {
    border-bottom: 1px solid #eee;
    padding-bottom: 15px;
    font-size: 16px;
    color: #666666;
    font-weight: 400;
  }
  .el-message-box__content {
    height: 98px;
    padding-top: 30px;
    font-size: 14px;
    color: #666666;
    font-weight: 400;
    box-sizing: border-box;
  }
  .el-message-box__btns {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    box-sizing: border-box;
    border-top: 1px solid #eee;
    .el-button {
      width: 80px;
    }
  }
  .el-message-box__btns button:nth-child(2) {
    margin-left: 20px;
  }
}
</style>
